import { useEffect } from 'react';
import { usePage } from '@inertiajs/react';
import Clarity from '@microsoft/clarity';
import classNames from 'classnames';
import GTMEventManager from '@/app/GTMEventManager.js';
import { useTranslations } from '@/app/i18n.js';

export default function ({ settings, min, max, onSelectTeam }) {
    const { uniq_id: uniqId, session_id: sessionId } = usePage().props.auth;
    const __ = useTranslations();
    const length = (max - min) + 1;

    useEffect(() => {
        window.scrollTo(0, 0);
        GTMEventManager.pageView('step_team');
        console.log(`[Clarity] session: ${uniqId} / ${sessionId} - step_team`);
        Clarity.identify(uniqId, sessionId, 'step_team');
    }, []);

    return (
        <section className="px-4 sm:px-5 md:px-6 dark:px-0 lg:mr-6 dark:mr-0 pb-4 sm:pb-8 pt-0">
            <div className="grid relative grid-cols-6" style={{ paddingTop: '2px' }}>
                {[...Array(length).keys()].map(i => (
                    <div
                        key={i + min}
                        className={classNames({
                            'border dark:border-lighter-gray border-smooth-gray dark:text-lighter-gray text-light-gray text-5xl sm:text-6xl md:text-7xl 3xl:text-8xl font-black px-6 sm:px-8 py-6 sm:py-10 3xl:py-12 dark:hover:bg-gray-100 hover:bg-medium-gray dark:hover:text-medium-gray hover:text-white transition cursor-pointer': true,
                            'col-span-2': true,
                            'col-span-3': (length === 2 || length % 3 === 2) && i >= length - 2,
                            'col-span-6': (length === 1 || length % 3 === 1) && i >= length - 1,
                            'border-t-0': i > 2,
                            'border-l-0': i % 3 !== 0,
                            'dark:border-l-0': i % 3 === 0,

                        })}
                        onClick={() => { onSelectTeam(i + min) }}
                    >
                        {i + min}
                    </div>
                ))}
                <div key="more" className="flex flex-col px-6 py-6 sm:py-16 col-span-6 gap-8 md:gap-12">
                    <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-8 md:mx-auto">
                        <span className="text-5xl sm:text-6xl md:text-7xl 3xl:text-8xl font-black text-medium-gray">{Math.min(12, max) + 1}+</span>
                        <p className="text-xs sm:text-base dark:text-medium-gray text-dark-gray max-w-md">
                            {__('book.index.steps.team.more_players_text.part_1', { count: Math.min(12, max) + 1 })}
                            <a
                                href={`mailto:${settings.contact.email}`}
                                className="text-primary hover:underline px-2"
                                onClick={() => GTMEventManager.contact('email', 'step_team')}
                            >
                                {settings.contact.email}
                            </a>
                            {__('book.index.steps.team.more_players_text.part_2')}
                        </p>
                    </div>
                    <div className="flex md:items-center justify-center md:gap-8 md:mx-auto dark:text-medium-gray text-dark-gray w-full md:max-w-md border border-medium-gray rounded px-4 md:px-8 py-4">
                        <p className="text-xs sm:text-base text-light-gray">{__('book.index.steps.team.age_limit_text.part_1')} <strong className="underline">{__('book.index.steps.team.age_limit_text.part_2')}</strong></p>
                    </div>
                </div>
            </div>
        </section>
    );
}
